import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=601ed379&"
import script from "./main-view.vue?vue&type=script&lang=js&"
export * from "./main-view.vue?vue&type=script&lang=js&"
import style0 from "./main-view.vue?vue&type=style&index=0&id=601ed379&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports